import { type FC } from 'react'
import { Modal as BootstrapModal } from 'react-bootstrap'
import { Modal } from '../../../../components/Modal/Modal'

interface TurnOffPublicBookingLinksModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  isConfirming?: boolean
}

export const TurnOffPublicBookingLinksModal: FC<TurnOffPublicBookingLinksModalProps> = ({ show, onHide, onConfirm, isConfirming = false }) => {
  return (
    <Modal
      header={<BootstrapModal.Title>Turning off public booking links?</BootstrapModal.Title>}
      body={
        <span className='paragraph-medium'>
          Clients won't be able to book through your booking page or event type links. Links you've sent for a specific booking will keep working. So will
          reschedule and cancel links on confirmed bookings.
        </span>
      }
      showFooterActions
      footerPrimaryActionTitle='Turn off'
      onFooterPrimaryAction={onConfirm}
      footerPrimaryActionLoading={isConfirming}
      centered
      show={show}
      onHide={onHide}
    />
  )
}
